<div class="customer categories">
  <div class="customer__header flex-wrap justify-between">
    <app-page-header
      pageTitle="Customers"
      [numberOfItem]="customersCount"
      (searchEvent)="handleSearch($event)"
      searchPlaceholder="Search"
      [loading]="
        isLoading &&
        (customersFilter | async)?.pageNumber === 1 &&
        !customersCount
      "
    >
    </app-page-header>

    <form
      class="customer__date flex-wrap justify-end"
      [formGroup]="customerFilterForm"
    >
      <div class="customer__date-input">
        <label>Start Date</label>
        <input type="date" formControlName="startDate" />
      </div>
      <div class="customer__date-input">
        <label>End Date</label>
        <input type="date" formControlName="endDate" />
      </div>

      <div class="customer__date-select">
      <div class="input-field">
        <label>Payment Status</label>
            <select formControlName="paymentStatus">
                <ng-container *ngFor="let status of payemntStatusOption">
                    <option [value]="status.value">{{ status.label }}</option>
                </ng-container>
            </select>
        </div>
      </div>
    </form>
  </div>

  <div class="table-block">
    <div class="table-block__wrap">
      <table class="isLoader">
        <tr>
          <th>Full Name</th>
          <th>Email</th>
          <th>Phone Number</th>
          <th>Plan Name</th>
          <th>Price</th>
          <th>Status</th>
          <th>Start Date</th>
          <th>End Date</th>
          <th>Terms in Months</th>
        </tr>
        <ng-container
          *ngIf="
            isLoading && (customersFilter | async)?.pageNumber === 1;
            else customersTable
          "
        >
          <ng-container *ngFor="let i of [].constructor(10)">
            <tr>
              <td>
                <app-skeleton
                  height="15px"
                  width="100px"
                  margin="0"
                ></app-skeleton>
              </td>
              <td>
                <app-skeleton
                  height="15px"
                  width="100%"
                  margin="0"
                ></app-skeleton>
              </td>
              <td>
                <app-skeleton
                  height="15px"
                  width="100px"
                  margin="0"
                ></app-skeleton>
              </td>
              <td>
                <app-skeleton
                  height="15px"
                  width="80px"
                  margin="0"
                ></app-skeleton>
              </td>
              <td>
                <app-skeleton
                  height="15px"
                  width="100px"
                  margin="0"
                ></app-skeleton>
              </td>
              <td>
                <app-skeleton
                  height="15px"
                  width="100%"
                  margin="0"
                ></app-skeleton>
              </td>
              <td>
                <app-skeleton
                  height="15px"
                  width="70px"
                  margin="0"
                ></app-skeleton>
              </td>
              <td>
                <app-skeleton
                  height="15px"
                  width="70px"
                  margin="0"
                ></app-skeleton>
              </td>
              <td>
                <app-skeleton
                  height="15px"
                  width="30px"
                  margin="0"
                ></app-skeleton>
              </td>
            </tr>
          </ng-container>
        </ng-container>
      </table>
    </div>
  </div>
</div>

<ng-template #customersTable>
  <ng-container *ngIf="customers.length > 0; else noDataFound">
    <ng-container *ngFor="let customer of customers; let i = index">
      <tr
        inViewport
        [lastElement]="customers.length === i + 1"
        (elementIsVisible)="loadMoreIfLastIndex()"
        [routerLink]="['/customers', customer.id]"
      >
        <td>
          <p>{{ customer.fullName | titlecase }}</p>
        </td>
        <td>{{ customer.email }}</td>
        <td>{{ customer.phone }}</td>
        <td>{{ customer.planName }}</td>
        <td>${{ customer.planCost }}</td>
        <td>{{ customer.paymentStatus }}</td>
        <td>{{ customer.startDate }}</td>
        <td>{{ customer.endDate }}</td>
        <td>{{ customer.termMonths }}</td>
      </tr>
    </ng-container>
    <tr *ngIf="isLoading && (customersFilter | async)?.pageNumber !== 1">
      <td>
        <app-skeleton height="15px" width="100px" margin="0"></app-skeleton>
      </td>
      <td>
        <app-skeleton height="15px" width="100%" margin="0"></app-skeleton>
      </td>
      <td>
        <app-skeleton height="15px" width="100px" margin="0"></app-skeleton>
      </td>
      <td>
        <app-skeleton height="15px" width="80px" margin="0"></app-skeleton>
      </td>
      <td>
        <app-skeleton height="15px" width="100px" margin="0"></app-skeleton>
      </td>
      <td>
        <app-skeleton height="15px" width="100%" margin="0"></app-skeleton>
      </td>
      <td>
        <app-skeleton height="15px" width="70px" margin="0"></app-skeleton>
      </td>
      <td>
        <app-skeleton height="15px" width="70px" margin="0"></app-skeleton>
      </td>
      <td>
        <app-skeleton height="15px" width="30px" margin="0"></app-skeleton>
      </td>
    </tr>
  </ng-container>
</ng-template>

<ng-template #noDataFound>
  <tr>
    <td colspan="3">
      <div class="table-block__nodata">No data found</div>
    </td>
  </tr>
</ng-template>
